import { Routes } from '@angular/router';

const title = 'Publicaciones';
const data = { title, isShowBreadcrumb: true };

export const ROUTES: Routes = [
  {
    path: 'perdida',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Pérdidas' }] },
        loadComponent: () => import('./pages/perdido-lista/perdido-lista.component'),
      },
    
    ],
  },

  
];
